<template>
    <div class="loans-details rating-b">

        <!-- título dá página/voltar -->
        <div v-for="item in this.Loan" v-bind:key="item._id" class="row tit_page">
            <div class="col-12">
                <div class="float-left">
                    <h1 >
                        Meus empréstimos
                        <span>{{ajustIdOportunidade(item.IdOportunidade, 5)}}</span>
                        <strong>{{formatted(item.Documento)}}</strong>
                    </h1>
                </div>

                <div class="options float-right">
                    <a @click="$router.go(-1)" href="javascript:;" title="Voltar">
                        <i class="back">&nbsp;</i> 
                        <span>Voltar</span>
                    </a>
                </div>
                <div class="clearfix"></div>
            </div>
        </div>
        <!-- final título dá página/voltar -->

        <hr class="divider">

        <div v-for="item in this.Loan" v-bind:key="item.IdOportunidade" class="row justify-content-center" style="height:500px;">
            <div class="col-12 col-md-8 col-lg-6 align-self-center aguarde text-center">
                
                <!-- inicio step 1 aguarde -->
                <div v-if=" Aguarde == '25%' ">
                    <h2>{{formatenome(item.Nome)}}, aguarde…</h2>
                    <div class="status">
                        <div class="emoticon text-center" style="width: 25%;">
                            <img src="/static/assets/images/emoji-animado.gif" alt="Emoji Animado">
                        </div>
                        <div class="progress">
                            <div class="progress-bar" role="progressbar" style="width: 25%;" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">25%</div>
                        </div>
                    </div>
                    <h3>Estamos analisando a sua solicitação</h3>
                    <p>Em breve você saberá se pode tomar um empréstimo através da IOUU.</p>
                </div>
                <!-- final step 1 aguarde -->


                <!-- inicio step 2 aguarde -->
                <div v-if=" Aguarde == '50%' ">
                    <h2>{{formatenome(item.Nome)}}, aguarde…</h2>
                    <div class="status">
                        <div class="emoticon text-center" style="width: 50%;">
                            <img src="/static/assets/images/emoji-entediado.gif" alt="Emoji entediado">
                        </div>
                        <div class="progress">
                            <div class="progress-bar" role="progressbar" style="width: 50%;" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100">50%</div>
                        </div>
                    </div>
                    <h3>Estamos analisando a sua solicitação</h3>
                    <p>Em breve você saberá se pode tomar um empréstimo através da IOUU.</p>
                </div>
                <!-- final step 2 aguarde -->

                <!-- inicio step 3 aguarde -->
                <div v-if=" (Aguarde == '75%' || (item.StatusAguarde == undefined && item.StatusAnalise == '' && item.Status == 'finished')) && (item.StatusAnalise != 'NEGADO' && item.StatusAnalise != 'NEGADO_' && item.Status != 'NEGADO')">
                    <h2>{{formatenome(item.Nome)}}, aguarde…</h2>
                    <div class="status">
                        <div class="emoticon text-center" style="width: 75%;">
                            <img src="/static/assets/images/emoji-ansioso.gif" alt="Emoji ansioso">
                        </div>
                        <div class="progress">
                            <div class="progress-bar" role="progressbar" style="width: 75%;" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100">75%</div>
                        </div>
                    </div>
                    <h3>Estamos analisando a sua solicitação</h3>
                    <p>Em breve você saberá se pode tomar um empréstimo através da IOUU.</p>
                </div>
                <!-- final step 3 aguarde -->

                <!-- inicio step 4 aprovado -->
                <div id="solicita" v-if="item.StatusAguarde == '100%' && (item.StatusAnalise != 'NEGADO' )">
                    <h2>{{formatenome(item.Nome)}}, solicitação aprovada!</h2>
                    <div class="status">
                        <div class="emoticon text-center" style="width: 100%;">
                            <img src="/static/assets/images/emoticon-feliz.svg" alt="Emoji feliz">
                        </div>
                        <div class="progress">
                            <div class="progress-bar" role="progressbar" style="width: 100%;" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100">100%</div>
                        </div>
                    </div>
                    <h3>A análise de sua proposta está completa.</h3>

                    <router-link :to="documentos('EMPCOL', item._id)" class="btn btn-lg btn-success" title="Ver detalhes da solicitação">Ver detalhes da solicitação</router-link>
                </div>
                <!-- final step 4 aprovado -->

                <!-- inicio step 5 negado -->
                <div v-if="item.StatusAnalise == 'NEGADO' || item.StatusAnalise =='NEGADO_' || item.Status == 'NEGADO'">
                    <h2>{{formatenome(item.Nome)}}, solicitação negada!</h2>
                    <div class="status">
                        <div class="emoticon text-center" style="width: 100%;">
                            <img src="/static/assets/images/emoticon-triste.svg" alt="Emoji triste">
                        </div>
                        <div class="progress">
                            <div class="progress-bar" role="progressbar" style="width: 100%;" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100">100%</div>
                        </div>
                    </div>
                    <h3 v-if="!item.NegadoCliente">A análise de sua proposta está completa.</h3>
                    <p v-if="!item.NegadoCliente">Infelizmente neste momento não poderemos ajudá-lo com seu pedido de empréstimo.</p>
                    <p v-if="item.NegadoCliente">Obrigado {{formatenome(item.Nome)}}, Estareamos a disposição a qualquer momento. </p>
                </div>
                <!-- final step 5 negado -->
                
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>
    @import "../assets/styles/iouu/variables";
    @import "../assets/styles/iouu/mixins";

    .tit_page {
        h1 {
            line-height: 20px;
            span {
                float:none;
            }
            strong {
                float:none;
            }
        }
        @include ds {
            h1 {
                @include font-size(25px);
            }

            span, strong {
                @include font-size(16px);
            }

            .back {
                a {
                    line-height: 20px;
                    margin: 5px 0;

                    span {
                        font-size: 12px;
                    }
                }
            }
        }
    }

    hr {
        @include ds {
            margin-top: 10px;
            margin-bottom: 20px;
        }
    }

    .aguarde {

        .status {
            margin: 50px 0 25px;

            @include ds {
                margin: 40px 0 20px;
            }
        }

        .emoticon {
            margin-bottom: 20px;

            img {
                width: 70px;
            }

            @include ds {
                margin-bottom: 15px;
                img {
                    width: 60px;
                }
            }
        }

        .progress {
            height: 22px;

            @include ds {
                height: 15px;
            }
        }

        p {
            padding-top: 10px;
            @include font-size(18px);
            color: #999;

            @include ds {
                @include font-size(14px);
            }
        }

        .btn {
            margin-top: 30px;

            text-transform: uppercase;
            font-weight: bold;
            @include font-size(18px);
            padding-left: 40px;
            padding-right: 40px;

            &-success {
                background: $c5;
                border: $c5;

                &:hover {
                    background: $c6;
                    border: $c6;
                }
            }
        }

        @include ds {
            h2 {
                @include font-size(25px);
            }
            h3 {
                @include font-size(20px);
            }
        }
    }
</style>

<script>
/* eslint-disable */
import Modal from "@/components/Modal";
import * as mutationTypes from "@/store/mutation-types.js";
import ApiClient from "@/utils/api-client";
import Masker from "@/utils/masker";
import ArrayHelper from "@/utils/array-helper";

export default {
  data() {
    return {
      Loan: null,
      Diferenca: 0,
      Aguarde : '',
      AprovadoCliente: false
    };
  },
  methods: {
  
    formatted(doc)
    {
        doc = doc.replace(/\D/g, '')
        
        if(doc.length > 12)
        return Masker.maskCnpj(doc)

        return Masker.maskCpf(doc)
    },
    formatenome(nome)
    {
        nome = nome != null ? nome.trim() : "";
        if(nome.indexOf(" ") != -1)
        {
            nome = nome.split(" ")[0]
            return nome.substring(0,1).toUpperCase() +  nome.substring(1);
        }

        return nome.substring(0,1).toUpperCase() +  nome.substring(1);
    },
    /*lowerCase(texto) {
      if (texto == null || texto == undefined || texto == "") return "";

      if (texto == "AA" || texto == "HR") return texto.toLowerCase();

      return texto[0].toLowerCase();
    },*/
    ajustIdOportunidade(id, qtd) {
      var s = String(id);
  
     if(id == undefined || id == 0)
     return "";

      while (s.length < (qtd || 2)) {
        s = "0" + s;
      }
      return "#"+s;
    },

        documentos(type, id) {
                return "/emprestimos/pre-aprovado-detalhes?type=" + type + "&id=" + id;
        },
        Detalhes(type, id) {
            return "/emprestimos/detalhes-do-emprestimo?type=" + type + "&id=" + id;
        },

        //tagueamento GA
        taggingGA() {
            this.$ga.page({
                page: '/emprestimos/pre-aprovado',
                title: 'Pré Aprovado',
            })
        },
    },
        computed: {
            //Retorna os dados do usuário que está acessando em um objeto 'User'
            User: function() {
            return this.$store.state.currentUser;
            },
            /*Show: function() {
                const query = this.$route.query;

                if(query.detalhe == '1')
                    return false;

                return true;
            }*/
        },
        components: { Modal },
        beforeCreate() {
            this.$store.commit(mutationTypes.START_LOADING);
            const query = this.$route.query
            /*if(query.detalhe == null) {
                this.show = false
            }*/
            //Retorna o empréstimo de acordo com o ID em um objeto emprestimo
            ApiClient.GetMeuEmprestimo(query.id)
            .then(response => {
                this.Loan = response;
                    //Tratamento de usuários que já estavam no banco antes da atualização dos status
                    if(this.Loan[0].AprovadoCliente == undefined && this.Loan[0].StatusAnalise == "APROVADO") {
                        this.AprovadoCliente = true;
                    }

                    if(this.Loan[0].FinishedDate != undefined && (this.Loan[0].StatusAnalise != "NEGADO" || this.Loan[0].StatusAnalise != "NEGADO_" || this.Loan[0].Status != "NEGADO")) { 
                        const miliSecs = (new Date(this.Loan[0].FinishedDate)) - (new Date())
                        const  diffDays = (-1) * Number.parseInt(miliSecs/1000/60/60/24)
                        //Modifica a animação de acordo com a data de Criação da proposta (Prazo de 48 horas)
                        if(this.Loan[0].StatusAguarde == '25%') { 
                            this.Diferenca = diffDays;
                            
                            if (diffDays == 1)  this.Aguarde = '50%';
                            else if (diffDays > 1) this.Aguarde = '75%';
                            else this.Aguarde = '25%';
                        }
                    } else if (this.Loan[0].StatusAguarde != '100%' && (this.Loan[0].StatusAnalise != "NEGADO" || this.Loan[0].StatusAnalise != "NEGADO_" || this.Loan[0].Status != "NEGADO")) {
                        this.Aguarde = '75%';
                    }
                   
                    this.$store.commit(mutationTypes.STOP_LOADING)
            })
            .catch(() => this.$store.commit(mutationTypes.STOP_LOADING));
    },
    async created() {
        //tagueamento GA
        await this.taggingGA();
    }

};
</script>


// WEBPACK FOOTER //
// src/views/Preapproved.vue